import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {getSound, enableSound, disableSound} from "../../utils/playSound";

const withSoundChange = (WrappedComponent) => {
  const SoundChangeDecorator = (props) => {
    const [checked, setChecked] = useState(true);
    
    useEffect(() => {
      let sound = getSound();
      setChecked(sound);
    }, []);

    const toggleSound = () => {
      if (checked) {
        disableSound();
      } else {
        enableSound();
      }
      setChecked(!checked);
    };

    return (
      <WrappedComponent {...props} checked={checked} onChange={toggleSound} />
    );
  };
  return SoundChangeDecorator;
};

export default withSoundChange;
